export default {
    baseStyle: (props) => ({
        modalContent: {
            margin: 0,
            borderRadius: '1rem',
            bgColor: 'white'
        },
        modalHeader: {
            paddingY: {base: 4, xl: 8},
            paddingX: {base: 4, lg: 4, xl: 6},
            bgColor: 'transparent',
            borderRadius: '1rem',
            textStyle: {base: 'medium3Xlarge', md: 'medium4Xlarge', xl: 'medium5Xlarge'},
            ...props.theme.textStyles.medium3Xlarge
        },
        modalBody: {
            bgColor: 'transparent',
            padding: 0,
            marginBottom: 0,
            borderRadius: '1rem'
        },
        linkTileContainer: {
            flex: 1,
            paddingX: {base: 4, lg: 4, xl: 6},
            paddingBottom: {base: 4, lg: 0}
        }
    }),
    defaultProps: {
        size: 'md'
    },
    parts: ['modalContent', 'modalHeader', 'modalBody', 'linkTileContainer']
}
